import { generateClient } from 'aws-amplify/api';
import type { GraphQLResult } from 'aws-amplify/api';
import { fetchAuthSession } from 'aws-amplify/auth';

const client = generateClient() as unknown as {
  graphql: (op: {
    query: string;
    variables?: Record<string, unknown>;
    authToken?: string;
  }) => Promise<GraphQLResult<unknown>>;
};

const extractGraphqlMessage = (err: unknown): string => {
  if (!err) return 'Unknown error';
  if (typeof err === 'string') return err;
  const e = err as { errors?: Array<{ message?: string }>; message?: string };
  if (Array.isArray(e.errors) && e.errors.length > 0) {
    return e.errors.map((er) => er?.message ?? JSON.stringify(er)).join('; ');
  }
  if (e.message) return e.message;
  try {
    return JSON.stringify(err);
  } catch {
    return String(err);
  }
};

export const gql = async <T>(
  query: string,
  variables?: Record<string, unknown>,
): Promise<T> => {
  let res: GraphQLResult<T>;
  try {
    const session = await fetchAuthSession();
    const authToken = session.tokens?.idToken?.toString();
    if (!authToken) throw new Error('ID tokenがありません。再ログインしてください。');
    res = (await client.graphql({ query, variables, authToken })) as GraphQLResult<T>;
  } catch (err) {
    throw new Error(extractGraphqlMessage(err), { cause: err });
  }
  if (res.errors && res.errors.length > 0) {
    throw new Error(res.errors.map((e) => e.message).join('; '));
  }
  if (!res.data) throw new Error('GraphQL response had no data');
  return res.data;
};
